import styled from "styled-components";
import { lgMin } from "../../../utils/constants";

export const CollateralContainer = styled.div`
  display: grid;
  grid-template-columns: 4fr 4fr;
  grid-column-gap: 30px;
  grid-row-gap: 16px;
`;

export const CurrentCollateralGrid = styled(CollateralContainer)`
  grid-template-areas:
    'purchasePrice priceDifference'
    'licensePlate collateralItem'
    'remainingLoanBalance getStatusBtn'
    'ownershipBalance .'
    'extraDeposit .'
    'totalDeposit totalDepositPercentage';
`;

export const NewCollateralGrid = styled(CollateralContainer)`
  grid-template-areas:
    'purchasePrice .'
    'licensePlate collateralItem'
    'seller sellerName'
    'collateralMilage mortageRegistration'
    'insurance insurance';

  @media all and (max-width: ${lgMin}) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'purchasePrice'
      'licensePlate'
      'collateralItem'
      'seller'
      'sellerName'
      'collateralMilage'
      'mortageRegistration'
      'insurance';
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  grid-area: ${({ gridArea }) => gridArea};
`;

export const VehicleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export const VehicleType = styled.div`
  margin-bottom: 10px;
`;

export const BtnBottomLeftWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
`; 